module.exports = {
  menu : {
    AccountCenter:'Account Center',
    // AccountCenter:'Nutzerkonto',//德国 endamoto.com
    EmployeeManagement:'Employee Management',
    // EmployeeManagement:'Benutzerverwaltung',     //德国 endamoto.com
    EmailAddress:'Email Address',
    Password:'Password',
    Login:'Login',
    ForgotPassword:'Forgot password',
    UserName:'User name',
    Distributor:'Distributor',
    Role:'Role',
    ChangePassword:'Change Password',
    AddAccount:'Add Account',
    Edit:'Edit',
    Delete:'Delete',
    DeleteAccount:'Delete account',
    DelAc:'After deleting the account, the member will no longer be able to continue using it. Are you sure to delete it?',
    FrameNumber:'Frame No.',
    EngineNumber:'Engine No.',
    State:'State',
    StorageDate:'Storage date',
    SaleDate:'Sale date',
    Operation:'Operation',
    Register:'Register',
    Details:'Details',
    Export:'Export',
    Download:'Download',
    VehicleName:'Vehicle name',
    Colour:'Colour',
    DeliveryDate:'Delivery Date',
    CustomerInformation:'Customer Information',
    CustomerType:'Customer type',
    licensePlateNumber:'License plate number',
    contactNumber:'Contact number',
    EmailAddress:'E-mail address',
    Address:'Address',
    PictureMaterials:'Picture materials',
    Save:'Save',
    Cancel:'Cancel',
    Modify:'Modify',
    PurchasementOfAccessoires:'Purchasement of accessoires',
    ApplicableModels:'Applicable models',
    All:'All',
    NO:'NO.',
    AddToCart:'Add',
    SoldOut:'Sold out',
    Attachment:'Attachment',
    VehicleModel:'Vehicle',
    MinimumPurchaseQuantity:'MOQ',
    MinimumPurchaseQuantitya:'Minimum Order Quantity',
    UnitUsage:'Unit usage',
    Alternative:'Alternative',
    ShoppingCart:'Shopping Cart',
    Code:'Part Code',
    Product:'Part Name',
    UnitPrice:'Price',
    Quantity:'Quantity',
    Quantitya:'Amount',
    SubTotal:'Sub total',
    InvalidProduct:'Invalid product',
    ClearInvalidProducts:'Clear invalid products',
    PaymentMethod:'Payment method',
    FreightMode:'Shipping type',
    PriceTerms:'Price terms',
    TransferAccounts:'Transfer accounts',
    AccountPayment:'Account payment',
    Remarks:'Remarks',
    Tips:'Tips',
    CheckoutSuccess:'Checkout success',
    DeliveryAddress:'Delivery address',
    Country:'Country',
    Addressee:'Addressee',
    OrderNumber:'Order No.',
    Currency:'Currency',
    PurchaseAmount:'Amount',
    DeliveryProgress:'Delivery Progress',
    Paymentmethod:'Payment method',
    OrderTime:'Order time',
    PendingReview:'Pending Review',
    Underreview:'Pending Review',
    PendingShipment:'Awaiting shipment',
    UnderDelivery:'Shipping',
    Completed:'Shipped out',
    ContractNumber:'Contract No.',
    PriceTerms:'Price terms',
    ProductDetails:'Product details',
    AddTo:'Add',
    PartCode:'Part code',
    PartName:'Part Name',
    OrderAmount:'Order amount',
    AddParts:'Add parts',
    DeliveryDetails:'Delivery details',
    ClaimOrder:'Claim Order',
    ClaimNumber:'Claim Number',
    Vehicle:'Vehicle',
    ClaimType:'Claim type',
    ClaimAmount:'Claim amount',
    ApplicationTime:'Application date',
    ClaimRecord:'Claim record',
    OperationRecord:'Operation record',
    Amount:'Amount',
    Operator:'Operator',
    OperationContent:'Operation content',
    TransactionSerialNumber:'Transaction slip No.',
    TransactionOrderNumber:'Transaction order No.',
    TransactionType:'Transaction type',
    IncomeAndExpenditureTypes:'Income and expenses type',
    AmountChanges:'Balance changes',
    Time:'Time',
    DocumentCenter:'Document Center',
    ScopeOfApplication:'Scope of application',
    Title:'Title',
    ReleaseTime:'Release time',
    Preview:'Preview',
    Bulletin:'Bulletin',
    Type:'Type',
    Receive:'Receive',
    LaborHourList:'Labor hour list',
    ApplyForClaim:'Garranty Requests',
    ProductName:'Product Name',
    WarrantyPeriod:'Warranty period',
    Customer:'Customer',
    Dealer:'Dealer',
    ClaimInformation:'Claim information',
    EventName:'Event Name',
    Mileage:'Mileage',
    ProblemDescription:'Problem description',
    Analysis:'Analysis',
    Solution:'Solution',
    ClaimDetails:'Claim details',
    RepairType:'Repair type',
    ClaimForLaborHour:'Claim for labor hour',
    StandardLaborCost:'Standard labor cost',
    LaborHours:'labor hours',
    LaborCost:'Labor Fee',
    SupportClaims:'Support claims',
    LobarHourCode:'Lobar hour code',
    CHDescriptionOfLaborHours:'CH description of labor hours',
    ENDescriptionOfLaborHours:'EN description of labor hours',
    StandardLaborHours:'Standard labor hours',
    InUse:'in use',
    Deactivated:'deactivated',
    LogOff:'Log off',
    //  LogOff:'Abmelden',     //德国 endamoto.com
    Income:'Income',
    ExpectedShippingdate:'Expected shippingdate(optional)',
    CustomerOrderNo:'Customer order No.(optional)',
    Kind:'Kind',
    Remarksaa:'Reasons for refusal',
    Rejected:'Rejected',
    Cancelled:'Cancelled',
    ExportOrder:'Export order',
    ExportDetails:'Export details',
    Expense:'Expense',
    Onlyunread:'Only unread',
    user:'User',
    Confirm:'Confirm',
    Inputthepassword:'Input the password',
    Basicinformation:'Basic information',
    search:'Search',
    Bykeywords:'By keywords',
    Startdata:'Start data',
    Enddata:'End data',
    to:'to',
    EntertheVIN:'Enter the VIN',
    Add:'Add',
    SUCESS:'SUCESS',
    unit:'Qty/unit',
    Effectivedate:'Effective date',
    Add:'Add',
    Bymodel:'By model',
    ByVIN:'By VIN',
    Claim:'Claim No.',
    Bypart:'By part',
    Countrya:'Country',
    Shippingtype:'Shipping type',
    Expected:'Expected shipping date(optional)',
    Enter:'Enter...',
    Submit:'Submit',
    Uploadorder:'Upload order',
    OrderNo:'Claim No.',
    Country:'Country',
    Reapply:'Re-apply',
    ItemNo:'Item No.',
    Accountdeduction:'Account deduction',
    Continueordering:'Continue ordering',
    Orderdetails:'Order details',
    Soldout:'Sold out',
    Total:'Total',
    items:'items',
    uesr:'Account Name',
    Edit:'Edit',
    item:'items',
    Import:'Import',
    Pleaseenter:'Please enter your username',
    Pleaseentera:'Please enter your password',
    yjcll:'Processed',
    CustomerName:'Customer name',
    MOQ:'MOQ',
    PartsImportTemplate:'Parts import template',
    SelectFile:'Select File',
    ShipmentInformation :'Shipment information',
    ShipmentNo:'Shipment No.',
    Qty:'Qty',
    ShipmentDate:'Shipment date',
    NoVehiclePartsInformationFound:'No vehicle parts information found',
    Novehiclemodelinformation :'No vehicle model information was found, and claims for this vehicle are not supported',
    Pleaseentertheframe:'Please enter the frame',
    Reset:'Reset',
    BulkRegistration:'Bulk Registration',
    Importtemplate:'Import template',
    
    Claimedpart:'Claimed part',
    Uploadfiles:'Select file',
    Note10M:'Note: Multiple files can be uploaded, and files in pdf, doc, and docx formats are supported, and the size of a single file cannot exceed 10M',
    Submitsuopei:'Submit',
    Cancelsuopei:'Cancel',
    AfterSalesAccountCurrency:'After-sales Account Currency',
    Success:'Success',
    Continue:'Continue',
    Viewtheorder:'View the order',
    Unread:'Unread',
    Approved:'Approved',
    Rejected2:'Rejected',
    Saletime:'Sale date',
    Timecaozuo:'Time',
    RegistrationDate:'Registration date',
    Unregistered:'Unregistered',
    Registered:'Registered',
    Mileage2:'Mileage(km)',
    FrameNo:'Vehicle',
    Failurecategory:'Failure category',
    Underreview:'Under review',
    Underreview2:'Under review',
    Underreview3:'Under review',
    Underreview4:'Under review',
    Partcategory:'Part category',
    Country1:'Country',
    Reasons:'Reasons for the dismissal',
    Vehicleorder:'Vehicle order',
    Partsorder:'Parts order',
    Parts:'Parts',
    Vehicle:'Vehicle',


    zcmxcx:'Model',
    zcmxyhxm:'Customer Name',
    zcmxlsh:'Retailer',
    zcmxzbdqsj:'Warranty Expiration Date',
    zcmxyczbqx:'Extended Warranty Period',
    
    zckckccz:'In Stock',
    zckckcjz:'Low Stock',
    zckczwkc:'Out of Stock',
    zckccx:'Model',
    zckcyc:'Color',
    zckcdqkc:'Current Stock',
    zckckcxx:'Inventory Offline',
    zckczt:'Status',
    zckccz:'Actions',
    zckcyjsz:'Warning Settings',

    wbdtj:'Add Maintenance Order',
    wbddh:'Maintenance Order Number',
    wbdlc:'Vehicle Mileage',
    wbdlss:'Service Dealer',
    wbdsj:'Service Date',
    wbdyfw:'Serviced',
     wbdylxr:'Contact Person',
    wbdylxfs:'Contact Information',
    wbdyfwxm:'Service Items',
    wbdymx:'Details',
    wbdysypj:'Used Parts',
    cldasclss:'Selling Dealer',

    cgwdpjdh:'Parts Order Number',
    cgwdxdrq:'Order Date',
    cgwdlx:'Type',
    cgwdpjbm:'Part Code',
    cgwdpjmc:'Part Name',
    cgwddgsl:'Ordered Quantity',
    cgwdyfh:'Shipped Quantity',
    cgwdwd:'Backorder',

    lssjxsmc:'Dealer Name',
    lssyx:'Email',
    lsszt:'Status',
    lsserp:'ERP Account Binding',
    
    fbwdwjlx:'File Type',
    fbwdsc:'Upload',
    fbwfbr:'Publisher',

    xspjfl:'Category',
    xspjsscx:'Applicable Model',
    xspjfy:'translate',
    xspjxsj:'Sales Price',
    xspjghgs:'Replacement Labor Cost',
    xspjwxgs:'Repair Labor Cost',
    xscxjg:'Currency',

    zhglbm:'Account Code',
   zhgllx:'Account Type',
   zhglyem:'Account Balance',
   zhglls:'Transaction Details',

   fhdfhsj:'Delivery Date',
   fhddh:'Delivery Note Number',
   fhdglpj:'Related Parts Order',
   fhdfhsl:'Delivered Quantity',
   shtgs:'Approved Quantity',
   sqsl:'Applied Quantity',
   sqyb:'Application',
   zsddlx:'Order type',
   sousuo:'Search',
    cbjg:'Cost price',
     erpzd:'Document preparation',
     zwshj:'No Data',
     clmxl:'Vehicle list',
     clstme:'Processing Date',
     dqzbsj:'Current Warranty Period',
     ycnx:'Extended Years',
     ychdqsj:'Expiry Date After Extension',
     yczbpoz:'Extended Warranty Certificate File',
     tgl:'Approved',
    jul:'Rejected',
    pfzl:'Compensating',
    ypfl:'Compensated',
    dkhqrl:'Pending Customer Confirmation',
    khjc:'Retailer abbreviation',
    khjca:'Retailer abbreviation',
    chejiahao:'vin',
    dailipei:'Pending Claim Settlement',
    yilipei:'Claim Settled',
     suopeishukl:'Claim Quantity',
     yipeifusl:'Compensated Quantity',
     dipeifusl:'Pending Compensation Quantity',
     xiaoshoudh:'Sales Order Number',
     quxiaolip:'Cancel the claim',
     zhgengchefahg:'Vehicle Delivery',
     peijianfh:'Parts Delivery',
     daizhid:'Pending Order Generation',
     tongzhiduix:'Notify the recipient',

       quanbulss:'All retailers',
    zhidingreny:'Designated personnel',
    mingxc:'Name',
    congnir:'Content',
    fabutongg:'Issue a notice',
    xiuggtongg:'Notice of Modification',
    weibaojil:'Maintenance Record',
    weibaoshijian:'Maintenance time',
    shengchengpeiqdan:'Generate part order',
    chuangjianxiaosd:'Create',
    peijianmingxi:'List of parts',
    bencipeifus:'Compensated Number',
    peijianzongs:'Total number of accessories',
    kehugongsi:'Customer',
    fahuod:'Delivery note',
    changchuanvin:'Upload vin',
    xiazaimuban:'Download the template',
    daifashul:'Quantity to be dispatched',
    bencufahuo:'Shipmented number',
     fahuozongshu:'Total number',
     chekuan:'Car model',
     shigonglex:'Type',
     weix:'Repair',
     genghuan:'Replacement',
     peijianjine:'Parts Amount',
      yitonggshul:'Approved Quantity',
  yipeifushul:'Compensated Quantity',
  shenhezhuangt:'Review Status',
  peijianzioee:'Total Parts Amount',
  gongshifzonge:'Total Labor Fee',
  xianggongclp:'Submit Claim toFactory',
  hezuozong:'Active',
  yizhjongzh:'Terminated',
  lingshousquanc:'Retailer Full Name',
  hezuozhuangt:'Cooperation Status',
  wenjianminame:'File Name',
  wenjian:'File',
   fabuwendang:'add',
   bianjiwendan:'Edit',
   lingshouzhanghzf:'Retail account payment',
    tianjiachexing:'Add vehicle model',
    caigoujiage:'Purchase Price',
    daijishushenhe:'Pending technical review',
    erlunpej:'Two-wheeler parts',
   silunpej:'Four-wheel vehicle parts',
   erlunzhengc:'A complete two-wheeler',
   silunzhengc:'Four-wheeler whole vehicle',
    erlunpejdd:'Two-wheeler parts order',
   silunpejdd:'Four-wheeler parts order',
   erlunzhengcdd:'Two-wheeler complete vehicle order',
   silunzhengcdd:'Order for a complete four-wheeler',
   gongchangsuopdh:'Factory claim number',
   zheshijiesuanjine:'Settlement amount',
   zhejsijiesuan:'Settlement',
    yijiesuanjine:'Settled amount',
   daijinsuanjin:'Amount to be settled',
   yuetiaozheng:'Balance adjustment',
   zengjia:'Increase',
   jiankou:'Deduction',
    fahuozhangt:'Shipping status',
   weiwancheng:'Unfinished',
   yiwancehng:'Shipped out',
   buxianzhi:'No restrictions',
   yishenql:'Application submitted',
    queddshanchuxuan:' Are you sure to delete the selected accessories?',
   plshanc:'Delete',
    zhoubianq:'Surrounding products',
    kuaijiedenglul:'Quick Login',
       tijiaojhishushene:'Submit for technical review',
        bohui:'Rejection',
        jishubanpdduan:'Technical judgment',
         chepaihao:"License plate NO.",
     baoyangxinxx:"Maintenance Information",
    baoyang:'Maintenance',
qingshangchaunss:'Please upload the driving license, mileage chart pictures, and pictures of the faulty parts (these are required for repairs).', 
chushenjuj:'Preliminary trial refused ',    
shucujujyy:'Please enter reason for rejection',
jishupand:'Technique decision',
suopk:'Support the claim？',
zhic:'Yes',
nozhic:'No',
dadijishupd:'Technical judgment',
tyReapply:'Agreed',
yueikou:'Balance deduction',
xiaddanzhoukbil:'Order discount rate',
shezhi:'settings',
yefy:'Balance',
dczdddk:'Maximum deduction of order amount per transaction',
zpnmji:'In total',
lingshousjianc:'Retailer abbreviation',
zhuanggjine:'Transfer amount',
fapiao:'Invoice',
xglshousshang:'Change Retailer',
xiugailintishi:'After changing the retailer, the vehicle profile ownership will be updated.',
xuanzelingshouss:'Select Retailer',
dayinbiaoq:'Print labels',
zanwuquanx:'No permission granted.',
beihuozhong:'Preparing',
tianjiacheliang:'Add vehicles',
piliangtianjial:'Batch addition',
dangqzhibdaoqihijian:'Expiry date of warranty period',
yanchangqixian:'Extension of the deadline',
yinian:'1 year',
liangnian:'2 years',
sannian:'3 years',
sinian:'4 years',
wunian:'5 years',
cheliangzongsshu:'Total number',
huruduochejiahaotihsi:'Enter multiple vehicle identification numbers separated by commas.',
dantaiyongl:'Single-unit usage',
shiwu:'physical parts',
xunijine:'Virtual credit',
caozuochengong:'Operation successful',
peifufanghui:'Compensation method',
fanhui:'Return',
quxiaofahuoo:'Cancel shipment',
zhekoudanjia:'Discount price',
zhekoujine:'Discount amount',
  },
}